<template>
  <AddEditMultiConnect key="edit" />
</template>

<script>
import AddEditMultiConnect from "@/views/AddEditMultiConnect";
export default {
  components: {
    AddEditMultiConnect,
  },
};
</script>

<style>
</style>